
import { Vue } from "vue-class-component";

export default class List extends Vue {}
